(() => {
  const selector = '.product-card__image > img, .product-single__thumbnail > img, .product__photo-wrapper > img:not(.zoomImg)';
  const registered = new WeakSet();
  const boundsCache = new Map();
  const known = window.cocoliliImageBounds || {};
  const full = { x: 0, y: 0, width: 1, height: 1 };
  const filename = url => new URL(url, location.href).pathname.split('/').pop().replace(/_(?:\d+x\d*|\d*x\d+|small|medium|large|grande)(?=\.)/, '');
  const source = img => img.currentSrc || img.src;
  function measure(img) {
    const canvas = document.createElement('canvas');
    const factor = Math.min(1, 256 / Math.max(img.naturalWidth, img.naturalHeight));
    canvas.width = Math.max(1, Math.round(img.naturalWidth * factor));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * factor));
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const w = canvas.width, h = canvas.height;
    const white = index => data[index + 3] < 16 || (data[index] >= 249 && data[index + 1] >= 249 && data[index + 2] >= 249);
    let border = 0, blank = 0;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (x < 2 || x >= w - 2 || y < 2 || y >= h - 2) {
          border++;
          if (white((y * w + x) * 4)) blank++;
        }
      }
    }
    if (blank / border < 0.98) return full;
    let left = w, right = 0, top = h, bottom = 0;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (!white((y * w + x) * 4)) {
          left = Math.min(left, x); right = Math.max(right, x);
          top = Math.min(top, y); bottom = Math.max(bottom, y);
        }
      }
    }
    if (left >= right || top >= bottom) return full;
    left = Math.max(0, left - 3); right = Math.min(w, right + 4);
    top = Math.max(0, top - 3); bottom = Math.min(h, bottom + 4);
    if ((right - left) * (bottom - top) / (w * h) < 0.16) return full;
    return { x: left / w, y: top / h, width: (right - left) / w, height: (bottom - top) / h };
  }
  function apply(img, bounds) {
    const frame = img.parentElement;
    const fw = frame.clientWidth, fh = frame.clientHeight;
    if (!fw || !fh || !img.naturalWidth || !img.naturalHeight) return;
    const iw = img.naturalWidth, ih = img.naturalHeight;
    const scale = Math.min(fw * 0.84 / (iw * bounds.width), fh * 0.84 / (ih * bounds.height));
    const width = iw * scale / fw * 100, height = ih * scale / fh * 100;
    img.style.setProperty('--cocolili-image-width', `${width}%`);
    img.style.setProperty('--cocolili-image-height', `${height}%`);
    img.style.setProperty('--cocolili-image-left', `${50 - width * (bounds.x + bounds.width / 2)}%`);
    img.style.setProperty('--cocolili-image-top', `${50 - height * (bounds.y + bounds.height / 2)}%`);
    img.dataset.cocoliliFramed = 'true';
  }
  function frameImage(img) {
    const url = source(img);
    if (!url || url.startsWith('data:') || !img.complete || img.naturalWidth < 2) return;
    const name = filename(url);
    const fixed = known[name];
    if (fixed) { apply(img, fixed); return; }
    if (boundsCache.has(url)) { apply(img, boundsCache.get(url)); return; }
    try {
      const bounds = measure(img);
      boundsCache.set(url, bounds);
      apply(img, bounds);
    } catch (_) {
      boundsCache.set(url, full);
      apply(img, full);
    }
  }
  const observer = new ResizeObserver(entries => {
    for (const entry of entries) entry.target.querySelectorAll(':scope > img:not(.zoomImg)').forEach(frameImage);
  });
  const inView = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) frameImage(entry.target);
  }, { rootMargin: '250px' });
  function register(root) {
    const images = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    for (const img of images) {
      if (registered.has(img)) continue;
      registered.add(img);
      img.addEventListener('load', () => frameImage(img));
      inView.observe(img);
      observer.observe(img.parentElement);
      frameImage(img);
    }
  }
  register(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches(selector)) frameImage(record.target);
      } else {
        for (const node of record.addedNodes) if (node.nodeType === 1) register(node);
      }
    }
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
